import React, { useState } from 'react'
import { Box, Grid, InputLabel } from '@material-ui/core'
import { FormContext, useForm } from 'react-hook-form'

import { Container, Page, ServiceUnreachableAlert } from 'components'
import { CookiesTagsForm, Header, ReportVersionTable } from './components'

import useSnackbar from 'hooks/useSnackbar'
import useBrowserReachability from 'hooks/useBrowserReachability'

import constants from 'constants/index'
import helpers from 'helpers'
import * as service from 'service'
import { schema } from './components/CookiesTagsForm'

import useStyles from './styles'

const CookiesTagsReport = () => {
  const [currentReportVersion, setCurrentReportVersion] = useState(null)
  const [exportingPdf, setExportingPdf] = useState(false)
  const [refresher, setRefresher] = useState(false)

  const classes = useStyles()
  const snackbar = useSnackbar()

  const cookiesService = useBrowserReachability(
    constants.externalServices.COOKIES_KEY,
  )

  const formMethods = useForm({
    validationSchema: schema,
    defaultValues: {
      reportSelected: '',
      bannerIds: [],
    },
  })

  const { triggerValidation, watch } = formMethods

  const values = watch()
  const { reportSelected, bannerIds } = values

  const { cookiesTags } = constants.reports.DESCRIPTION

  const handleRefresh = () => setRefresher((prev) => !prev)

  const buildReportParams = () => {
    const params = {}

    if (reportSelected === constants.cookies.reports.REPORT_TYPES.COMPLETE) {
      params.complete = true
      return params
    }

    if (reportSelected === constants.cookies.reports.REPORT_TYPES.BY_BANNER) {
      if (bannerIds.length > 0) {
        params.bannerIds = bannerIds.map((banner) => banner.id)
      }
    }

    return params
  }

  const handleExportPdf = async () => {
    const isValid = await triggerValidation()
    if (!isValid) return

    try {
      setExportingPdf(true)

      const params = buildReportParams()

      const response = await service.dponet.cookieTags.exportReport({
        ...params,
        shouldCreateVersion: !currentReportVersion?.id,
      })

      const { url } = response.data
      window.open(url, '_blank')
    } catch (error) {
      snackbar.open({
        message: helpers.formatters.errorMessage(error?.response?.data?.error),
        variant: 'error',
      })
    } finally {
      setTimeout(handleRefresh, 5000)
      setExportingPdf(false)
    }
  }

  return (
    <FormContext {...formMethods}>
      <Page className={classes.root} title="Relatório de Tags de Cookies">
        <Container maxWidth={false} spacingXl={15} spacingLg={10} spacingMd={5}>
          <Box py={5}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Header
                  type="cookiesTags"
                  reportTour="cookiesTags"
                  isLoading={exportingPdf}
                  buttonAction={handleExportPdf}
                  disabled={exportingPdf || !cookiesService.isReachable}
                  title={cookiesTags.title}
                  description={cookiesTags.content}
                  buttonType="button"
                />
              </Grid>
              <Grid item xs={12}>
                <ServiceUnreachableAlert
                  services={[constants.externalServices.COOKIES_KEY]}
                />
                <InputLabel className={classes.label}>
                  Filtros de pesquisa:
                </InputLabel>
                <CookiesTagsForm />
              </Grid>
              <Grid item xs={12}>
                <ReportVersionTable
                  currentReportVersion={currentReportVersion}
                  kind={constants.reportVersions.KIND.COOKIES_TAGS}
                  refresher={refresher}
                  setCurrentReportVersion={setCurrentReportVersion}
                />
              </Grid>
            </Grid>
          </Box>
        </Container>
      </Page>
    </FormContext>
  )
}

export default CookiesTagsReport
